import React, {useState, useEffect} from "react";
import ReactPDF from "@react-pdf/renderer";
import { format, parse, parseISO } from "date-fns";
import { authenticatedApi, getAccessToken, serialize/*, , setAccessToken, tokenName, unauthenticatedApi*/ } from "api";
import MaestroRelationship from "./MaestroRelationship";

import MaestroSelect from "./MaestroSelect";
// import { useAuth } from "../AuthProvider";
import { Box, Button, DialogActions, DialogTitle, Divider, FormControl, FormLabel, Input, Modal, ModalDialog, ModalOverflow } from "@mui/joy";
import { useAuth } from "@providers/AuthProvider";
import toast from "react-hot-toast";
import MaestroLoader from "@components/MaestroLoader";
import { useTenant } from "@providers/TenantProvider";
import { CONSTANT_CONTACT_ID } from "config";

const toastId = 'send-to';

const SendToModal = (props) => {
    const ccId = CONSTANT_CONTACT_ID;// 'az5f8hq58ynzzgeh67b46xgd'; // taken from .env b/c process.env.REACT_APP_CONSTANT_CONTACT_ID isn't available in production
    // console.log(props.objects); // todo: compare businesses vs contacts

    const { tenant, connectedAccounts, getConnectedAccounts/*, setConnectedAccounts*/ } = useTenant();

    const [saving, setSaving] = useState(false);
    const [loading, setLoading] = useState(false);

    const [destinations, setDestinations] = useState([]);
    const [destination, setDestination] = useState(null);

    const [listName, setListName] = useState('');
    const [lists, setLists] = useState([]);
    const [list, setList] = useState(null);

    const [recheckConnectedAccounts, setRecheckConnectedAccounts] = useState(false);

    const checkDestinations = () => {
        checkDestinationsAsync();
    };

    const checkDestinationsAsync = async () => {
        if(!props?.isOpen) {
            return;
        }

        let allDestinations = [];

        setLoading(true);
        // this is a workaround to get the connected accounts when they don't appear correctly the first time
        if(Object.keys(connectedAccounts).length === 0 && !recheckConnectedAccounts) {
            await getConnectedAccounts();
            setRecheckConnectedAccounts(true);
        }

        // console.log(connectedAccounts);

      if (connectedAccounts.hasOwnProperty('mailchimp') && connectedAccounts.mailchimp.status == 'connected') {
        allDestinations.push({value: 'mailchimp', label: 'Mailchimp'});
      }

      if (connectedAccounts.hasOwnProperty('constantContact') && connectedAccounts.constantContact.status == 'connected') {
        allDestinations.push({value: 'constant_contact', label: 'Constant Contact'});
      }

      setDestinations(allDestinations);
      setLoading(false);
    };

    useEffect(checkDestinations, [tenant, connectedAccounts, props.isOpen]);
    // useEffect(checkDestinations, [tenant]);

    useEffect(() => {
        if(!props?.isOpen) {
            return;
        }

        setLoading(true);
        setLists([]);

        let allLists = [{value: 'new', label: 'Create New List', count: 0}];

        let $data = {
            method: 'GET',
        };

        if(destination === null) {
            setLists(allLists);
            setLoading(false);
            return;
        } else if (destination.value == 'mailchimp') {
            $data['url'] = connectedAccounts.mailchimp['value']['payload']['endpoint'] + "/3.0/lists";
            $data['headers'] = ['Authorization: Basic ' + btoa('anytext:' + connectedAccounts.mailchimp['value']['payload']['token'])];
        } else if (destination.value == 'constant_contact') {
            $data['url'] = "https://api.constantcontact.com/v2/lists?api_key="+ccId;//process.env.REACT_APP_CONSTANT_CONTACT_ID;
            $data['headers'] = ['Authorization: Bearer ' + connectedAccounts.constantContact['value']['payload']['token']];
        }

        authenticatedApi.get('proxy?'+serialize($data), {}, false).then(response => response.data).then(response => {
            if (destination.value == 'mailchimp') {
                for(const $list of response.lists) {
                    allLists.push({value: $list.id, label: $list.name, 'count': $list.stats ? $list.stats.member_count : 0});
                }
            } else if (destination.value == 'constant_contact') {
                if(response.data && response.data.length && response.data[0].hasOwnProperty('error_message')) {
                    toast.error('Constant Contact Error: '+response.data[0].error_message, {id: toastId});
                }
                for(const $list of response.data) {
                    allLists.push({value: $list.id, label: $list.name, 'count': $list.contact_count ? $list.contact_count : 0});
                }
            }

            setLists(allLists);
            setLoading(false);
        });
    }, [destination]);

    const send = async () => {
        setSaving(true);

        let listId = null;

        if(list === null) {
            setSaving(false);
            toast.error('You must choose or create a list to send to.', {id: toastId});
            return;
        }

        // if we're creating a new list, we need to do that first
        if(list.value === 'new') {
            let $list_post_data = {
                name: listName
            };

            let $list_data = {
                method: 'POST',
            };

            if(destination.value === 'mailchimp') {
                $list_post_data = {
                    ...$list_post_data,

                    contact: connectedAccounts.mailchimp.contact,
                    permission_reminder: "You have been included from our community's list",
                    campaign_defaults: {
                        from_name: tenant.name,
                        from_email: tenant.admin_email,
                        subject: listName,
                        language: "en",
                    },
                    email_type_option: false,
                    double_optin: false,
                    marketing_permissions: false,
                };

                $list_data['url'] = connectedAccounts.mailchimp['value']['payload']['endpoint'] + "/3.0/lists";
                $list_data['headers'] = ['Authorization: Basic ' + btoa('anytext:' + connectedAccounts.mailchimp['value']['payload']['token'])];
            } else if(destination.value === 'constant_contact') {
                $list_post_data['status'] = 'ACTIVE';

                $list_data['url'] = "https://api.constantcontact.com/v2/lists?api_key="+ccId;//process.env.REACT_APP_CONSTANT_CONTACT_ID;
                $list_data['headers'] = [
                    'Authorization: Bearer ' + connectedAccounts.constantContact['value']['payload']['token'],
                    'Content-Type: application/json',
                ];
            } else {
                setSaving(false);
                toast.error("You must choose the destination you are sending to.", {id: toastId});
                return;
            }

            $list_data['data'] = JSON.stringify($list_post_data);

            const saveNewList = await authenticatedApi.get('proxy?'+serialize($list_data), {}, false);
            const newList = saveNewList;//.json();

            if(newList.hasOwnProperty('status') && newList.status === 403) {
                let description = 'An error occurred while creating a new list.';
                if(destination.value === 'mailchimp') {
                    description += ' You may need to upgrade your Mailchimp account to add more audiences.'
                }
                setSaving(false);
                toast.error(description, {id: toastId});
                return;
            }

            listId = newList.id; // TODO: handle validation issues
        } else {
            listId = list.value;
        }

        let objectsToPush = [];
        props.objects.map(object => {
            if(object.email === null || object.email.trim().length == 0) {
                return;
            }

            let preferred_phone;
            if(object.preferred_contact_method !== 'email') {
                preferred_phone = object[object.preferred_contact_method+'_phone'];
            } else if(object.work_phone) {
                preferred_phone = object.work_phone;
            } else if(object.cell_phone) {
                preferred_phone = object.cell_phone;
            } else if(object.home_phone) {
                preferred_phone = object.home_phone;
            }

            if(props.type === 'contacts') {
                let obj = {
                    email_addresses: [
                        object.email
                    ],
                    first_name: object.first_name,
                    last_name: object.last_name,
                    company_name: object.company_name,
                    home_phone: preferred_phone,//object[object.preferred_phone+'_phone'],
                    addresses: [{
                        line1: object.address,
                        line2: object.address_2,
                        city: object.city,
                        address_type: "PERSONAL",
                        state_code: object.state_province,
                        country_code: object.country,
                        postal_code: object.zip_postal
                    }]
                };

                objectsToPush.push(obj);
            } else if(props.type === 'businesses') {
                let obj = {
                    email_addresses: [
                        object.email
                    ],
                    // first_name: object.first_name,
                    // last_name: object.last_name,
                    company_name: object.name,
                    work_phone: object.phone,
                    addresses: [{
                        line1: object.address_mail,
                        line2: object.address_2_mail,
                        city: object.city_mail,
                        address_type: "BUSINESS",
                        state_code: object.state_province_mail,
                        country_code: object.country_mail,
                        postal_code: object.zip_postal_mail
                    }]
                };

                objectsToPush.push(obj);
            }
        });

        if(!objectsToPush.length) {
            setSaving(false);
            toast.error("No records will be sent. Check that records have an email address.", {id: toastId});
            return;
        }

        let $sends = [];
        let chunkSize = 499;
        for (let i = 0; i < objectsToPush.length; i += chunkSize) {
            if (destination.value == 'mailchimp') {
                $sends.push(sendContactsToMailchimp(objectsToPush.slice(i,i+chunkSize), listId));
            } else if (destination.value == 'constant_contact') {
                $sends.push(sendContactsToConstantContact(objectsToPush.slice(i,i+chunkSize), listId));
            }
        }

        Promise.allSettled($sends).then((results) => {
            let notGood = 0;
            results.map(result => {
                if(result.status == 'rejected') {
                    notGood++;
                }
            });

            if(notGood === 0) {
                toast.success('The record(s) with an email have been successfully sent.', {id: toastId});
            } else if (notGood > 0 && notGood < $sends.length) {
                toast.error('The record(s) with an email have been sent but there were a few errors.', {id: toastId});
            } else {
                toast.error('The record(s) failed to send.', {id: toastId});
            }

            setSaving(false);
            props.onClose();
        })

    };

    function sendContactsToMailchimp(contacts, $id) {
        var $post_data = {
            members: [],
            update_existing: false
        };

        contacts.map($contact => {
            let $email = {
                email_address: $contact.email_addresses[0],
                status: 'subscribed',
                merge_fields: {}
            };

            if($contact.hasOwnProperty('first_name') || $contact.hasOwnProperty('company_name')) {
                $email.merge_fields.FNAME = $contact.hasOwnProperty('first_name') ? $contact.first_name : $contact.company_name;
            }

            if($contact.hasOwnProperty('last_name')) {
                $email.merge_fields.LNAME = $contact.last_name;
            }
            if($contact.hasOwnProperty('home_phone') || $contact.hasOwnProperty('work_phone')) {
                $email.merge_fields.PHONE = $contact.hasOwnProperty('home_phone') ? $contact.home_phone : $contact.work_phone;
            }

            $post_data.members.push($email);
        })

        var $data = {
            url: connectedAccounts.mailchimp['value']['payload']['endpoint'] + "/3.0/lists/"+$id,
            method: 'POST',
            headers: ['Authorization: Basic ' + btoa('anytext:' + connectedAccounts.mailchimp['value']['payload']['token'])],
            data: JSON.stringify($post_data)
        };

        return authenticatedApi.get('proxy?'+serialize($data), {}, false);
    }

    function sendContactsToConstantContact(contacts, $id) {
        let columnNames = [];
        if(props.type === 'contacts') {
            columnNames = [
                "EMAIL",
                "FIRST NAME",
                "LAST NAME",
                "COMPANY NAME",
                "HOME PHONE",
                "ADDRESS LINE 1",
                "ADDRESS LINE 2",
                "CITY",
                "STATE",
                "COUNTRY",
                "Zip/Postal Code",
            ];
        } else if(props.type === 'businesses') {
            columnNames = [
                "EMAIL",
                // "FIRST NAME",
                // "LAST NAME",
                "COMPANY NAME",
                "WORK PHONE",
                "ADDRESS LINE 1",
                "ADDRESS LINE 2",
                "CITY",
                "STATE",
                "COUNTRY",
                "Zip/Postal Code",
            ];
        }

        var $post_data = {
            lists: [$id],
            import_data: contacts,
            column_names: columnNames
        };

        var $data = {
            url: "https://api.constantcontact.com/v2/activities/addcontacts?api_key="+ccId,//process.env.REACT_APP_CONSTANT_CONTACT_ID,
            method: 'POST',
            headers: [
                'Authorization: Bearer ' + connectedAccounts.constantContact['value']['payload']['token'],
                'Content-Type: application/json'
            ],
            data: JSON.stringify($post_data)
        };

        return authenticatedApi.get('proxy?'+serialize($data), {}, false);
    }

    return (
    <Modal open={props.isOpen} onClose={props.onClose}>
        <ModalOverflow>
        <ModalDialog>
            <DialogTitle>Send To</DialogTitle>
            {/* {saving === false && <ModalCloseButton />} */}
            <Divider/>
            {destinations.length === 0 && !loading && (
                <Box>
                    It looks like you don't have any valid integrations at the moment.<br/>Check your settings to connect to an integrated service.
                </Box>
            )}
            {(destinations.length > 0 || loading) && (<>
            <Box>
                {(loading == false || destinations.length > 0) && (<>
                <FormControl>
                    <FormLabel htmlFor='send_to'>
                        {props.type === 'contacts' && (<span>Send {props.objects.length} {props.objects.length === 1 ? 'contact' : 'contacts'} to:</span>)}
                        {props.type === 'businesses' && (<span>Send {props.objects.length} {props.objects.length === 1 ? 'business' : 'businesses'} to:</span>)}
                    </FormLabel>
                    {/* <Input id='send_to' type='text' required /> */}
                    {/* <FormHelperText>We'll never share your email.</FormHelperText> */}
                    <MaestroSelect options={destinations} value={destination} onChange={(selected) => {setDestination(selected)}} />
                </FormControl>
                </>)}
                {loading == true && (<Box sx={{display: 'flex', justifyContent: 'center'}}><MaestroLoader centered/></Box>)}
                {destination !== null && loading == false && (<>
                <FormControl sx={{mt: 1}}>
                    <FormLabel htmlFor='select_list'>
                        Select a list to send to:
                    </FormLabel>

                    <MaestroSelect options={lists} selected={list} onChange={(selected) => setList(selected)} />
                </FormControl>

                {list !== null && list.value == 'new' && (
                    <FormControl sx={{mt: 1}}>
                        <FormLabel htmlFor='list_name'>New list name:</FormLabel>
                        <Input id='list_name' type='text' required value={listName} onChange={event => setListName(event.target.value)} />
                        {/* <FormHelperText>We'll never share your email.</FormHelperText> */}
                    </FormControl>
                )}
                </>)}
            </Box>

            <DialogActions>
                <Button
                    variant="solid"
                    color="primary"
                    // colorScheme='brand'
                    onClick={send}
                    disabled={!destination || list === null || (list.value === 'new' && !listName) || saving}
                    loading={saving}
                >
                Send
                </Button>
            </DialogActions>
            </>)}
        </ModalDialog>
        </ModalOverflow>
    </Modal>
    );
}

export default SendToModal;
